import request from '@/utils/request'

/**
 * GISer Acknowledgment API (منطقية الرفع المساحي)
 * Shares the existing survey chat — do not call separate GISer chat endpoints.
 * Base: /projects/{projectId}/giser-acknowledgment
 */

const base = projectId => `/projects/${projectId}/giser-acknowledgment`

/** GET /giser-acknowledgment — includes can_acknowledge + surveyor_acknowledgment + geodesia_acknowledgment + same survey chat */
export const getGiserAcknowledgment = projectId => request({
  url: base(projectId),
  method: 'get',
})

/** POST /giser-acknowledgment/save — body: { acknowledged: true } */
export const saveGiserAcknowledgment = (projectId, data) => request({
  url: `${base(projectId)}/save`,
  method: 'post',
  data,
})

/** GET /giser-acknowledgment/recipients?keyword= — users with role مساح بالطبيعة */
export const getGiserAcknowledgmentRecipients = (projectId, params = {}) => request({
  url: `${base(projectId)}/recipients`,
  method: 'get',
  params,
})

/** POST /giser-acknowledgment/save-and-send — body: { acknowledged: true, recipient_user_ids: [] } */
export const saveAndSendGiserAcknowledgment = (projectId, data) => request({
  url: `${base(projectId)}/save-and-send`,
  method: 'post',
  data,
})
